import styled, {css} from 'styled-components';

//helpers
import {commonPalette} from 'styles/palette';

//constants
const innerRadius = 6;
const outerRadius = 9;
const thickness = 1;

export const RadioButton = styled.div`
  ${p =>
    p.design === 'default' &&
    css`
      ${ClickableArea} {
        display: inline-flex; // only the circle and the caption are clickable
      }

      ${Caption} {
        margin-left: 8px;
      }
    `}

  ${p =>
    p.design === 'fill-line' &&
    css`
      ${ClickableArea} {
        display: flex; // the whole line is clickable
        padding: 0 24px;

        &:hover {
          color: ${commonPalette.textBrand};
        }
      }

      ${Circle} {
        color: inherit !important;
      }

      ${Caption} {
        margin-left: 10px;
      }
    `}
`;

export const ClickableArea = styled.div`
  align-items: center;
  cursor: pointer;
  height: ${({height}) => (height ? height : 48)}px;

  ${p =>
    p.disabled &&
    css`
      cursor: default;
      opacity: 0.5;
      pointer-events: none;
    `}
`;

export const Circle = styled.div`
  border-radius: 50%;
  border: ${thickness}px solid ${commonPalette.borderGrey};
  height: ${2 * outerRadius}px;
  padding: ${outerRadius - innerRadius - thickness}px;
  width: ${2 * outerRadius}px;

  &::after {
    background: ${commonPalette.surfaceBrand};
    border-radius: ${innerRadius}px;
    content: '';
    display: block;
    height: ${2 * innerRadius}px;
    transition: 0.2s transform ease;
    width: ${2 * innerRadius}px;
  }

  ${p =>
    p.checked
      ? `
    color: ${commonPalette.textBrand};
  `
      : `
    &::after {
      transform: scale(0.1);
      visibility: hidden;
    }
  `}
`;

export const Caption = styled.div`
  font-size: 14px;
  line-height: 20px;
`;
